import Icon from 'Components/Base/Icon'
import React, { useState } from 'react'
import styled from 'styled-components'

const DropdownWrapper = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  position: relative;
  min-height: 50px;
  margin-bottom: 30px;
`

const SelectedTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 30px;
  padding-right: 20px;
`

const Tag = styled.div`
  background-color: #006d77;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;

  span {
    margin-left: 8px;
    cursor: pointer;
    font-weight: bold;
  }
`

const DropdownToggle = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
  color: #666;
`

const OptionsList = styled.div`
  margin-top: 8px;
  border-top: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
`

const Option = styled.div`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`
type Option = { selected: boolean; option: string }
interface props {
  options: Option[]
  selected: Option[]
  handleSetOptions: (options: Option) => void
}

const MultiSelectDropdown = ({ options, selected, handleSetOptions }: props) => {
  const [open, setOpen] = useState(false)

  const handleChildClick = (e) => {
    e.stopPropagation() // Prevents event from bubbling to container
  }

  return (
    <DropdownWrapper onClick={() => setOpen(!open)}>
      <SelectedTags>
        {selected
          .filter((option: Option) => option.selected)
          .map((item) => (
            <Tag key={item.option} onClick={(e) => handleChildClick(e)}>
              {item.option} <span onClick={() => handleSetOptions(item)}>×</span>
            </Tag>
          ))}
      </SelectedTags>
      <DropdownToggle>{open ? <Icon name="chevron-up" /> : <Icon name="chevron-down" />}</DropdownToggle>
      {open && (
        <OptionsList onClick={(e) => handleChildClick(e)}>
          {options.map((option) => (
            <Option key={option.option} onClick={() => handleSetOptions(option)}>
              {option.option}
            </Option>
          ))}
        </OptionsList>
      )}
    </DropdownWrapper>
  )
}

export default MultiSelectDropdown
